import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import Swal from "sweetalert2";

const columns = [
  {
    accessor: "target_date",
    header: "Target Date",
  },
  {
    accessor: "work_order_id",
    header: "Work Order ID",
    cell: (row) => <>{row?.work_order?.work_order_code ? row?.work_order?.work_order_code : "-"}</>,
  },
  {
    accessor: "production_qty",
    header: "Production Quantity",
  }
];

const DailyProductionReport = () => {
  const privileges = secureLocalStorage.getItem("privileges");
  const navigate = useNavigate();
  const [dailyProductionEntries, setDailyProductionEntries] = useState(5);
  const [dailyProductionPageIndex, setDailyProductionPageIndex] = useState(0);
  const [search, setSearch] = useState("");

  // Review
  // as useFetch and useDelete belongs to same end point
  // they can be imported from the same useAPIQuery hook

  const { useFetch } = useAPIQuery({
    key: "daily_production_report",
    endpoint: "/api/daily-production-report/",
  });

  const { data, isLoading } = useFetch({
    params: {
      entries: dailyProductionEntries,
      page_no: dailyProductionPageIndex + 1,
      event: search ? search : undefined,
    },
    abortOnNewRequest: true,
    refetchOnWindowFocus: false,
    staleTime : 1000 * 60 * 3,
    retry : 3,
    keepPlaceholder : true,
    refetchOnReconnect : true
  });

  const { useDelete } = useAPIQuery({
    key: "daily_production_report",
    endpoint: "/api/daily-production-report/",
  });

  const { mutate: deleteData } = useDelete();

  const handleGlobalFilterChange = (value) => {
    setSearch(value);
  };

  const handlePagination = (value) => {
    console.log(value);
    setDailyProductionPageIndex(value.pageIndex);
    setDailyProductionEntries(value.pageSize);
  };

  const handleEditRow = (row) => {
    console.log(row);
    navigate("/edit-daily-production-report", { state: { editpost: row.original } });
  };

  const handleDeleteRow = (row) => {
    console.log(row);
    const entry_id = row.original.id;
    Swal.fire({
      text: "Are you sure? You will not be able to recover this data!",
      showDenyButton: true,
      confirmButtonText: "Yes",
      denyButtonText: `No, cancel!`,
    }).then((result) => {
      if (result.isConfirmed) {
        deleteData({ id: entry_id });
      }
    });
  };

  return (
    <>
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <div className="nk-block-head-content d-flex">
            <h3 className="nk-block-title page-title">Daily Production Report</h3>
            {isLoading ? (
              <div className="spinner-border text-primary ms-2" role="status">
                <span className="sr-only"></span>
              </div>
            ) : (
              ""
            )}
          </div>
          {privileges.includes("daily_production_create") && (
            <div className="nk-block-head-content">
              <NavLink
                to="/create-daily-production-report"
                className="toggle btn btn-icon btn-primary d-md-none"
                id="button-button-create-daily-production-report"
              >
                <em className="icon ni ni-plus"></em>
              </NavLink>

              <NavLink
                to="/create-daily-production-report"
                className="toggle btn btn-primary d-none d-md-inline-flex"
                id="button-button-create-daily-production-report"
              >
                <em className="icon ni ni-plus"></em>
                <span>Create Daily production Report</span>
              </NavLink>
            </div>
          )}
        </div>
      </div>

      <Table
        data={data ? data?.results.data : []}
        columns={columns}
        pagination
        pageIndex={dailyProductionPageIndex}
        pageSize={dailyProductionEntries}
        rowCount={data ? data.count : 0}
        globalSearch
        editRows={privileges.includes("daily_production_update") ? true : false}
        deleteRows={privileges.includes("daily_production_delete") ? true : false}
        filterModal={false}
        selectRows={false}
        onGlobalFilterChange={handleGlobalFilterChange}
        onRowEdit={handleEditRow}
        onRowDelete={handleDeleteRow}
        onPaginationChange={handlePagination}
      />
    </>
  );
};

export default DailyProductionReport;
